import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M26.25 12.5H3.75M20 2.5v5m-10-5v5m3.125 10L15 16.25v6.25m-1.563 0h3.126m-6.813 5h10.5c2.1 0 3.15 0 3.953-.409a3.75 3.75 0 0 0 1.638-1.639c.409-.802.409-1.852.409-3.952V11c0-2.1 0-3.15-.409-3.952a3.75 3.75 0 0 0-1.639-1.64C23.4 5 22.35 5 20.25 5H9.75c-2.1 0-3.15 0-3.952.409a3.75 3.75 0 0 0-1.64 1.639C3.75 7.85 3.75 8.9 3.75 11v10.5c0 2.1 0 3.15.409 3.953a3.75 3.75 0 0 0 1.639 1.638c.802.409 1.852.409 3.952.409z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }